export default __webpack_public_path__ + "static/media/Tamarin Battle Spire.35ba276a.jpg";